import React from 'react';

import { Svg, useSvgColor } from '~/assets/icons/styles';

const QuestionMarkIcon = ({ color = '', ...props }) => {
  const svgColor = useSvgColor(color);

  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={svgColor}
      {...props}
    >
      <path
        d="M12.7054 15.6988C12.5181 15.5115 12.2639 15.4062 11.999 15.4062C11.734 15.4062 11.4799 15.5115 11.2926 15.6988C11.1053 15.8862 11 16.1403 11 16.4053C11 16.6702 11.1053 16.9243 11.2926 17.1116C11.4799 17.299 11.734 17.4043 11.999 17.4043C12.2639 17.4043 12.5181 17.299 12.7054 17.1116C12.8927 16.9243 12.998 16.6702 12.998 16.4053C12.998 16.1403 12.8927 15.8862 12.7054 15.6988Z"
        fill="currentColor"
      />
      <path
        d="M12.1258 7.53291C11.3879 7.60801 10.7666 8.13715 10.6019 8.94093C10.5264 9.30921 10.2687 9.64946 9.89467 9.68753C9.52067 9.72559 9.17931 9.45144 9.20325 9.07626C9.30972 7.40774 10.4774 6.27111 11.9817 6.11799C13.6826 5.94487 15.3316 6.98173 15.5258 8.88948C15.6827 10.4316 14.7533 11.6184 13.5638 12.125C12.9375 12.3815 12.4877 12.6522 12.5638 13.3994L12.5766 13.5945C12.6015 13.9753 12.3205 14.3076 11.9408 14.3462C11.5512 14.3859 11.2033 14.1022 11.1636 13.7126L11.1464 13.5437C10.9911 12.0175 11.8256 11.3061 12.9994 10.8011C13.6447 10.5748 14.1986 9.76346 14.1241 9.03215C14.0189 7.99878 13.0549 7.43833 12.1258 7.53291Z"
        fill="currentColor"
      />
      <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5" />
    </Svg>
  );
};

export default QuestionMarkIcon;
